import React from 'react'
import PropTypes from 'prop-types'
import AdviserSearchResultsList from '../AdviserSearchResultsList'
import { actions, events } from './adviserSearchResultsListContainerActions'
import { connect } from 'react-redux'
import history from '../../core/history'
import Spinner from '../../common/Spinners/Spinner'
import { bindActionCreators } from 'redux'

class AdviserSearchResultsListContainer extends React.Component {
  static propTypes = {
    fetchSearchResults: PropTypes.func.isRequired,
    profiles: PropTypes.array,
    loading: PropTypes.bool,
    currentPage: PropTypes.number.isRequired,
    fetchNextPage: PropTypes.func.isRequired,
    searchCriteria: PropTypes.object.isRequired,
    searchResults: PropTypes.array.isRequired,
    hasMorePages: PropTypes.bool.isRequired,
    pageSize: PropTypes.number.isRequired,
    urlSearchCriteria: PropTypes.object,
    fetchFindIfaByNameSearchResults: PropTypes.func.isRequired,
    userLocation: PropTypes.string,
    publishedAdviserProfiles: PropTypes.array.isRequired,
    filterProfiles: PropTypes.func.isRequired,
    sortByRatingAscending: PropTypes.func,
    sortByRatingDescending: PropTypes.func.isRequired,
    sortByDistanceAscending: PropTypes.func.isRequired,
    sortByDistanceDescending: PropTypes.func,
    fetchAllPages: PropTypes.func.isRequired,
    fetchPage: PropTypes.func.isRequired,
    shouldRefreshResults: PropTypes.bool.isRequired,
    isDetailedSearch: PropTypes.bool.isRequired,
    currentSort: PropTypes.string.isRequired
  };

  static sortOptions = [
    {
      value: events.sort.byDistanceAscending,
      data: 'Distance to adviser'
    },
    {
      value: events.sort.byRatingDescending,
      data: 'Adviser rating'
    }
  ];

  constructor (props) {
    super(props)

    this.contactAdviser = this.contactAdviser.bind(this)
    this.viewProfile = this.viewProfile.bind(this)
    this.loadNextPage = this.loadNextPage.bind(this)
    this.initiateSearchBarSearchFromUrl = this.initiateSearchBarSearchFromUrl.bind(
      this
    )
    this.sortProfiles = this.sortProfiles.bind(this)
    this.fetchPage = this.fetchPage.bind(this)
  }

  initiateSearchBarSearchFromUrl (adviserName, pageSize) {
    this.props.fetchFindIfaByNameSearchResults(
      adviserName,
      true,
      pageSize || 10
    )
  }

  componentDidMount () {
    if (!this.props.loading) {
      if (
        this.props.urlSearchCriteria?.adviserName &&
        this.props.shouldRefreshResults
      ) {
        this.initiateSearchBarSearchFromUrl(
          this.props.urlSearchCriteria.adviserName,
          this.props.pageSize
        )
      } else if (this.props.shouldRefreshResults) {
        let searchCriteria = {
          url: this.props.urlSearchCriteria || {},
          store: this.props.searchCriteria || {}
        }
        const firstPage = 1
        const resetFilterToSortByDistance = true
        this.props.fetchSearchResults(
          firstPage,
          this.props.pageSize,
          searchCriteria,
          this.props.userLocation,
          resetFilterToSortByDistance
        )
      }
    }
  }

  contactAdviser (profile) {
    if (!profile) return
    const adviserNameNoSpace = (profile.adviserName || '').split(' ').join('_')
    history.push(`/adviser/${encodeURIComponent(adviserNameNoSpace)}/${profile.adviserId}/contact`, { adviserId: profile.adviserId })
  }

  viewProfile (profile) {
    if (!profile) return
    const adviserNameNoSpace = (profile.adviserName || '').split(' ').join('_')
    const smallProfile = { adviserId: profile.adviserId, adviserName: adviserNameNoSpace }
    history.push(`/adviser/${encodeURIComponent(smallProfile.adviserName)}/${smallProfile.adviserId}/profile/view`, { adviser: smallProfile })
  }

  fetchPage (page) {
    this.props.fetchPage(this.props.searchResults || [], page, this.props.pageSize)
    const sidebarContentContainer = document.getElementsByClassName(
      'sidebar-content-container'
    )[0]
    if (sidebarContentContainer) sidebarContentContainer.scrollTop = 0
  }

  loadNextPage () {
    this.props.fetchNextPage(
      this.props.searchResults || [],
      this.props.currentPage,
      this.props.pageSize
    )
  }

  sortProfiles (sortType) {
    const {
      sortByRatingDescending,
      sortByDistanceAscending
    } = this.props

    const {
      byRatingDescending,
      byDistanceAscending
    } = events.sort

    switch (sortType) {
      case byRatingDescending:
        sortByRatingDescending()
        break
      case byDistanceAscending:
        sortByDistanceAscending()
        break
    }
  }

  render () {
    // Spinner while the search is loading OR matches exist but their cards haven't
    // loaded yet (profiles fills in as each published profile resolves). Without the
    // second condition the page briefly shows "No Results were found" with no spinner.
    const totalResults = (this.props.searchResults || []).length
    const profilesNotReady = totalResults > 0 && (this.props.profiles || []).length === 0
    if (this.props.loading || profilesNotReady) {
      return <Spinner />
    }

    if (totalResults === 0) {
      return <h2>No Results were found</h2>
    }
    return (
      <AdviserSearchResultsList
        loadPage={() => {
          this.props.fetchAllPages(
            this.props.searchResults || [],
            this.props.currentPage,
            this.props.pageSize
          )
        }}
        fetchAllPages={() => {
          this.props.fetchAllPages(
            this.props.searchResults || [],
            this.props.currentPage,
            this.props.pageSize
          )
        }}
        currentPage={this.props.currentPage}
        sortOptions={AdviserSearchResultsListContainer.sortOptions}
        currentSort={this.props.currentSort}
        sortProfiles={this.sortProfiles}
        profiles={this.props.profiles || []}
        contactAdviser={this.contactAdviser}
        viewProfile={this.viewProfile}
        loadNextPage={this.loadNextPage}
        hasMorePages={this.props.hasMorePages}
        pageSize={this.props.pageSize}
        totalMatchingProfiles={(this.props.searchResults || []).length}
        userLocation={this.props.userLocation}
        fetchPage={this.fetchPage}
        isDetailedSearch={this.props.isDetailedSearch}
      />
    )
  }
}

const mapStateToProps = ({
  publishedAdviserProfiles,
  searchResults,
  findAnIfa
}) => ({
  publishedAdviserProfiles: publishedAdviserProfiles || [],
  searchResults: searchResults.profileIds || [],
  currentSort: searchResults.lastSort,
  loading: searchResults.loading,
  profiles: searchResults.profiles || [],
  currentPage: searchResults.currentPage,
  searchCriteria: findAnIfa.searchCriteria || {},
  hasMorePages: searchResults.hasMorePages,
  pageSize: searchResults.pageSize,
  userLocation: findAnIfa.searchCriteria?.userAddress || '',
  shouldRefreshResults: findAnIfa.searchCriteria?.shouldRefreshResults || false
})

const mapDispatchToProps = dispatch => {
  const { sort, fetch, filter } = actions
  return bindActionCreators(
    {
      sortByRatingDescending: sort.byRatingDescending,
      sortByDistanceAscending: sort.byDistanceAscending,
      fetchSearchResults: fetch.searchResults,
      fetchNextPage: fetch.nextPage,
      fetchFindIfaByNameSearchResults: fetch.findIfaByNameResults,
      filterProfiles: filter.profiles,
      fetchAllPages: fetch.allPages,
      fetchPage: fetch.page
    },
    dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(
  AdviserSearchResultsListContainer
)
